/**
 * PortraitGameUI
 * Handles UI panels for portrait view.
 */

// ==================== Imports ====================
import BaseGameUI from '../gameui/BaseGameUI'

export default class PortraitGameUI extends BaseGameUI {

    // ==================== Construction ====================
    constructor(game) {
        super(game);

        this.goalCompletedSign = PARAMS.makeSprite(game, -140 * PARAMS.scaleFactor, 106 * PARAMS.scaleFactor, 'gameElements', 'levelCompleteSign.png');
        this.goalCompletedSign.anchor.set(0.5);
        this.view.add(this.goalCompletedSign);

        this.topPanel = PARAMS.makeSprite(game, 0 * PARAMS.scaleFactor, 70 * PARAMS.scaleFactor, 'gameElements', 'topPanelPortrait.png');
        this.topPanel.anchor.set(0.5);
        this.view.add(this.topPanel);

        this.bottomPanel = PARAMS.makeSprite(game, 0 * PARAMS.scaleFactor, 695 * PARAMS.scaleFactor, 'gameElements', 'bottomPanelPortrait.png');
        this.bottomPanel.anchor.set(0.5);
        this.view.add(this.bottomPanel);

        this.bombPanel = PARAMS.makeSprite(game, -104 * PARAMS.scaleFactor, 70 * PARAMS.scaleFactor, 'gameElements', 'bombActivePanelPortrait.png');
        this.bombPanel.anchor.set(0.5);
        this.bombPanel.alpha = 0;
        this.view.add(this.bombPanel);

        this.bombFiller = PARAMS.makeSprite(game, -229.5 * PARAMS.scaleFactor, 49 * PARAMS.scaleFactor, 'gameElements', 'bombChargerPortrait.png');
        this.bombFiller.alpha = 0;
        this.view.add(this.bombFiller);

        this.widthForFullInficator = this.bombFiller.width;
        this.bombFiller.cropRect = new Phaser.Rectangle(0, 0, 0, this.bombFiller.height);
        this.bombFiller.updateCrop();

        this.view.x = 518 / 2 * PARAMS.scaleFactor;
        this.view.y = 0;

        this.levelText = this.addTextElement2(-145, 35, 'blue', 'Level ' + game.level, 20);
        this.rightText = this.addTextElement2(-147, 685, 'green', '', 35);
        this.wrongText = this.addTextElement2(-147, 685, 'red', '', 35);
        this.wordPointsText = this.addTextElement2(-150, 720, 'white', '', 24);
        this.scoreText = this.addTextElement2(150, 675, 'white', 'Score:', 24);
        this.totalPointsText = this.addTextElement2(150, 710, 'white', '' + game.score, 35);
        this.timerText = this.addTextElement2(150, 35, 'blue', 'Time:', 20);
        this.timeLeftText = this.addTextElement2(150, 88, 'whiteNumbers', '', 50);
        this.goals = this.addTextElement2(-145, 68, 'white', 'Goal', 22);
        this.currentGoals = this.addTextElement2(-145, 95, 'white', 'Lines 0/' + game.goal, 30);
        this.bombCounterText = this.addTextElement2(-5, 105, 'blue', 'x 8', 22);

        this.goalCompleteMark = PARAMS.makeSprite(game, -70 * PARAMS.scaleFactor, 60 * PARAMS.scaleFactor, 'flashAnims', 'goalCompleteAnimation/0000');
        this.goalCompleteMark.anchor.set(0.5);
        this.goalCompleteMark.alpha = 0;
        this.view.add(this.goalCompleteMark);

        this.goalCompletedText = this.addTextElement2(0, 10, 'blue', 'Goal completed', 14);
        this.goalCompletedSign.addChild(this.goalCompletedText);

        this.bombInstructionText = this.addTextElement2(150, 140, 'white', 'Drag Bomb To Use', 14);
        this.bonusBombText = this.addTextElement2(-145, 95, 'white', 'Bonus Bomb', 26);
        this.bonusBombText.alpha = 0;

        var frames = window.Phaser.Animation.generateFrameNames('goalCompleteAnimation/', 0, 34, '', 4);
        this.goalCompleteMark.animations.add('show', frames, 20, false);
        this.goalCompleteMark.events.onAnimationComplete.add(function () {
            this.goalCompleteMark.alpha = 0
        }, this);

        // Buttons
        this.buttonExit = this.addButton(-23, 720, 'exitButton', this.onButtonExit);
        this.buttonPause = this.addButton(23, 720, 'statsButton', this.onButtonPause);
        this.buttonMute = this.addButton(23, 674, 'unmuteButton', this.onButtonUnmute);
        this.buttonUnmute = this.addButton(23, 674, 'muteButton', this.onButtonMute);
        this.buttonHelp = this.addButton(-23, 674, 'helpButton', this.onButtonHelp);

        this.currentWordFontSize = 35;
        this.currentWordMaxLength = 160;
    }

    // ==================== Initialization ====================
    init(game) {
        super.init(game);
        this.goalCompletedSign.y = 106 * PARAMS.scaleFactor;
    }
}
